import { inject, Injector } from '@angular/core';
import { signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { initialFormaGiuridicaCerState } from './forma_giuridica_cer.state';
import { getFormaGiuridicaCer } from './forma_giuridica_cer.utility';
import { GetFormaGiuridicaCerGQL } from '../../_graphql/generated';

export const FormaGiuridicaCerStore = signalStore(
  { providedIn: 'root' },
  withState(initialFormaGiuridicaCerState),
  withProps(() => ({
    getter: inject(GetFormaGiuridicaCerGQL),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getFormaGiuridicaCer(injector, store, getter),
  })),
);
